/**
 * @generated SignedSource<<b5f2299be3580e20abc617f560954bf0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AsanaIntegrationProjectsQuery$variables = {
  externalWorkspaceId: string;
  query?: string | null;
};
export type AsanaIntegrationProjectsQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly asana: {
        readonly projectsForWorkspace: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
          readonly type: string | null;
        }>;
      } | null;
    };
  };
};
export type AsanaIntegrationProjectsQuery = {
  response: AsanaIntegrationProjectsQuery$data;
  variables: AsanaIntegrationProjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalWorkspaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "externalWorkspaceId",
      "variableName": "externalWorkspaceId"
    },
    {
      "kind": "Variable",
      "name": "query",
      "variableName": "query"
    }
  ],
  "concreteType": "AsanaProjectNode",
  "kind": "LinkedField",
  "name": "projectsForWorkspace",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationProjectsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AsanaIntegrationProjectsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AsanaUserNode",
                "kind": "LinkedField",
                "name": "asana",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d622d1299595112eb04c868e860be55e",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationProjectsQuery",
    "operationKind": "query",
    "text": "query AsanaIntegrationProjectsQuery(\n  $query: String\n  $externalWorkspaceId: String!\n) {\n  viewer {\n    integrations {\n      asana {\n        projectsForWorkspace(query: $query, externalWorkspaceId: $externalWorkspaceId) {\n          id\n          name\n          type\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7525383639892ccd776cda8396c862f";

export default node;
